// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1U2AU","row":"ProcedureTreatmentSummary_row__2TtSY"};